<template lang="pug">
api-form(
  v-model="value"
  :fields="fields"
  :method="save"
  :initial="initial"
  :successCallback="successCallback"
  :btn-props="{ btnText: initial.id ? 'Сохранить' : 'Создать' }"
  v-bind="$attrs"
)
</template>
<script>
import CategoriesAutocomplete from '../CategoriesAutocomplete.vue';

export default {
  props: {
    initial: { type: Object, default: () => {} },
  },
  data() {
    return {
      value: this.initial || {},
    };
  },
  computed: {
    fields() {
      return [
        {
          component: 'v-text-field',
          text: 'Название',
          value: 'name',
          rules: 'required',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          component: 'v-textarea',
          text: 'Описание',
          value: 'description',
          component_attrs: {
            filled: true,
            rounded: true,
            'auto-grow': true,
            rows: 2,
            'row-height': 20,
            class: 'mb-5',
          },
        },
        {
          component: CategoriesAutocomplete,
          text: 'Категории',
          rules: this.value?.isRequest ? 'required' : '',
          value: 'mentoring_categories',
          component_attrs: {
            'return-object': true,
            filled: true,
            rounded: true,
          },
        },
        {
          component: 'v-checkbox',
          text: 'заявочная анкета',
          value: 'isRequest',
          component_attrs: {
            filled: true,
            rounded: true,
            class: 'mb-5 mt-0',
          },
        },
        ...this.value?.isRequest ? [{
          component: 'v-select',
          text: 'Выберите категорию',
          rules: 'required',
          value: 'selected',
          component_attrs: {
            disabled: !this.value?.mentoring_categories?.length,
            items: this.value.mentoring_categories || [],
            itemValue: 'id',
            itemText: 'name',
            filled: true,
            rounded: true,
          },
        }] : [],
      ];
    },
  },
  methods: {
    successCallback({ data }) {
      this.$emit('success', data.data.id);
    },
    save({ data }) {
      const payload = {
        name: data.name,
        description: data.description,
        mentoring_categories: data.mentoring_categories
          && data.mentoring_categories.map(({ id }) => ({
            id,
            is_for_request: data.selected === id,
          })),
      };
      const { initial } = this;
      if (initial?.id) return this.$api.mentoring.updateQuestionnaire(initial.id, payload);
      return this.$api.mentoring.createQuestionnaire(payload);
    },
  },
};
</script>
